import { forwardRef } from 'react'
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@pogokid/mui'
import { useRouterNavigation } from '~/router.ts'
import { isInternalLink } from '~m/designSystem/interactions'

declare module '@mui/material/Button/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true
  }
}

export interface ButtonProps extends MuiButtonProps {
  openInNewTab?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ href, openInNewTab, ...props }, ref) => {
    const { push } = useRouterNavigation()
    const onClick =
      props.onClick ||
      (isInternalLink(href)
        ? () => push(href!)
        : openInNewTab
        ? () => window.open(href, '_blank')
        : undefined)
    return (
      <MuiButton
        ref={ref}
        {...props}
        color={props.color ?? 'neutral'}
        onClick={onClick}
        href={onClick ? undefined : href}
      />
    )
  }
)
Button.displayName = 'Button'

export const ButtonBasic = forwardRef<
  HTMLButtonElement,
  ButtonProps
>((props, ref) => {
  return (
    <MuiButton
      ref={ref}
      {...props}
      color={props.color ?? 'neutral'}
    />
  )
})
ButtonBasic.displayName = 'ButtonBasic'
